import React from "react";
import { ArrowRight } from "lucide-react";
import { Reveal } from "../hooks/useReveal";

export default function FeatureSection({ id, data, reverse, onContact }) {
  return (
    <section id={id} className="bg-paper">
      <div className="grid grid-cols-1 lg:grid-cols-2">
        <div className={`group relative h-[340px] overflow-hidden md:h-[640px] ${reverse ? "lg:order-2" : "lg:order-1"}`}>
          <img
            src={data.img}
            alt={data.title}
            className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1600ms] ease-out group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-black/10" />
        </div>

        <div className={`flex items-center px-6 py-16 md:px-16 md:py-0 ${reverse ? "lg:order-1" : "lg:order-2"}`}>
          <div className="max-w-xl">
            <Reveal>
              <p className="inline-block border-b border-bronze pb-2 font-sans text-[11px] uppercase tracking-[0.3em] text-ink/60">
                {data.kicker}
              </p>
            </Reveal>
            <Reveal delay={80}>
              <h2 className="mt-6 font-sans text-2xl font-light uppercase tracking-[0.25em] text-ink sm:text-4xl">
                {data.title}
              </h2>
            </Reveal>
            <Reveal delay={140}>
              <p className="mt-7 text-[14px] font-light leading-[1.9] text-ink/60">{data.body}</p>
            </Reveal>
            <Reveal delay={220}>
              <button
                onClick={onContact}
                className="group mt-9 flex items-center gap-3 bg-bronze/90 px-8 py-3.5 font-sans text-[11px] uppercase tracking-[0.3em] text-[#F1E6D7] transition-all duration-500 hover:bg-bronze"
              >
                {data.cta}
                <ArrowRight size={14} className="transition-transform duration-300 group-hover:translate-x-1" />
              </button>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
